import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isIOS } from 'react-device-detect';

// Constants
import { configs } from '@constants/configs/configs';
import { FormattedMessage } from 'react-intl';
import { formatDate } from '@utils/dates/date.utils';
import { DESC_FORMAT_10 } from '@utils/dates/dateFormats.utils';
import { cleanQueryParams } from '@utils/miscellaneous/urlSearchParams';

const EmailShow = props => {

    const {
        emailShown: {
            emailSubject,
            fullName,
            date,
            pdfFileKey,
            switchLanguage,
            language
        },
        environment: {
            impersonation,
            impersonationDetails
        },
        accessibility: {
            isEnlargedFontEnabled
        }, 
        setEmailShown,
        hhidQueryParams,
        selectedMember
    } = props;

    const {
        endpoints: {
            EMAIL_PDF_PREVIEW,
            EMAIL_PDF_PREVIEW_WITH_IMPERSONATION
        }
    } = configs;

    const [ currentLang, setcurrentLang ] = useState(language);
    const [ isDisabled, setDisableBtn ] = useState(false);

    const getDate = timestamp => formatDate(timestamp, DESC_FORMAT_10);
    const isRead =  hhidQueryParams && selectedMember && hhidQueryParams  === selectedMember.encHouseHoldId ? false :  !impersonation;

    const urlHouseholdId =  new URLSearchParams(window.location.search);

    const getQueryParam = (search: string = '', key: string): string | null => {
        const params = new URLSearchParams(search);
        return params.get(key);
    };
    
    const getHouseholdIdFromUrl = () => getQueryParam(window.location.search, 'hhid');

    const householdId = impersonationDetails?.encryptedHouseholdId || getHouseholdIdFromUrl();

    const isOriginalLanguage = language === currentLang;

    const generatePDFUrl = () => {
        //regenerate new PDF
        return switchLanguage && !isOriginalLanguage ?
            householdId ?
                EMAIL_PDF_PREVIEW_WITH_IMPERSONATION.processReplacements({ pdfFileKey, read: isRead, isEnlarged: isDisabled, language: currentLang, householdId: householdId })
                : 
                EMAIL_PDF_PREVIEW.processReplacements({ pdfFileKey, read: isRead, isEnlarged: isDisabled, language: currentLang })    
            :
            //generate original PDF
            householdId ?
                EMAIL_PDF_PREVIEW_WITH_IMPERSONATION.processReplacements({ pdfFileKey, read: isRead, isEnlarged: isDisabled, language: '', householdId: householdId })
                : 
                EMAIL_PDF_PREVIEW.processReplacements({ pdfFileKey, read: isRead, isEnlarged: isDisabled, language: '' }); 
    };

    const [ pdfUrl, setPdfUrl ] = useState( generatePDFUrl() );


    useEffect(() => {
        setPdfUrl( generatePDFUrl() );
    }, [ currentLang, isDisabled ]);

    const handler = (bool) => {
        setDisableBtn(bool);
    };

    const toggleLangHandler = () => {
        setcurrentLang(currentLang === 'EN' ? 'ES' : 'EN');
    };

    return (
        <div id='rightpanel'>

            <button
                className='usa-button gi-button gi-button__secondary'
                onClick={() => setEmailShown(null)}
            >
                <FormattedMessage id='common.back_to_inbox' />
            </button>

            <div className='header'>
                <h2 className='title'>{emailSubject}</h2>
            </div>

            <div className='gray graybg gutter10 clearfix'>
                <table className='table table-condensed table-border-none none'>
                    <tbody>
                        <tr>
                            <td><FormattedMessage id='label.email.to' /></td>
                            <td>{fullName}</td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id='label.email.sent' /></td>
                            <td>{getDate(date)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {
                switchLanguage &&
                <div className='display-flex flex-column flex-align-end margin-bottom-105'>
                    <button
                        data-automation-id='toggle_pdf_language' 
                        className='usa-button gi-button gi-button__primary' 
                        aria-label='toggle pdf language' 
                        onClick={ toggleLangHandler } 
                    >
                        {

                            currentLang === 'ES' ? 
                                <FormattedMessage id='label.language.english' />
                                : 
                                <FormattedMessage id='label.language.spanish' />     
                        }
                    </button>
                </div>
            }
            {
                isEnlargedFontEnabled && 
                <div className='grid-row margin-y-5'>
                    <h3 className='margin-right-auto'>Your Notice</h3>
                    <span>
                        <button 
                            data-automation-id='btn_decrease-text-size' 
                            className='usa-button gi-button gi-button__secondary' 
                            aria-label='Decrease text size' 
                            onClick={ () => handler(false) } 
                            disabled={!isDisabled}
                        >
                            A- Decrease text size
                        </button>
                        <button
                            data-automation-id='btn_increase-text-size'
                            className='usa-button gi-button gi-button__secondary' 
                            aria-label='Increase text size' 
                            onClick={ ()=> handler(true) } 
                            disabled={isDisabled} 
                        >
                            A+ Increase text size
                        </button>
                    </span>
                </div>
            }
            {  
                isIOS ?
                    <a
                        className='usa-button gi-button gi-button__primary margin-b-10'
                        href={ pdfUrl }
                        role='button'
                        rel='noopener noreferrer'
                    >
                        <FormattedMessage id='common.view_doc'/>
                    </a>
                    :
                    <iframe
                        src={ pdfUrl }
                        className='preview_pdf_iframe'
                        scrolling='auto'
                        id='pdf_preview'
                        data-automation-id='pdf_preview'
                    />
            }
        </div>
    );
};

const mapStateToProps = state => {
    const search = state.router?.location?.search || '';
    const urlParams = new URLSearchParams(search);
    const cleanedParams = cleanQueryParams(urlParams);
    const hhidQueryParams = cleanedParams.hhid;

    return {
        environment: state.common.environment,
        accessibility: state.accessibility,
        hhidQueryParams,
        selectedMember: state.common?.sessionDataReducer?.selectedMember
    };
};
export default connect(mapStateToProps)(EmailShow);